import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface ConfirmDeleteDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  entityType: string;
  entityName?: string;
  additionalWarning?: string;
}

const ConfirmDeleteDialog: React.FC<ConfirmDeleteDialogProps> = ({
  open,
  onClose,
  onConfirm,
  entityType,
  entityName,
  additionalWarning,
}) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Delete {entityType}</DialogTitle>
    <DialogContent>
      <Typography>
        Are you sure you want to delete {entityName ? `${entityType.toLowerCase()} "${entityName}"` : `this ${entityType.toLowerCase()}`}?
        {additionalWarning ? ` ${additionalWarning}` : ' This action cannot be undone.'}
      </Typography>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose}>Cancel</Button>
      <Button onClick={onConfirm} color="error" variant="contained">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteDialog;
